import { Button } from '@/components/ui/button';
import { getMe } from '@/lib/api';
import { useCartStore } from '@/store/cart';
import { PencilIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useRouter } from '@tanstack/react-router';

const scrollToCart = () => {
  const footer = document.querySelector('footer');
  if (footer) {
    footer.scrollIntoView({ behavior: 'smooth' });
  }
};

export default function Credit() {
  const [isVisible, setIsVisible] = useState(true);
  const router = useRouter();
  const {
    availableCredits,
    getTotalCartCredits,
    updateAvailableCredits,
    products,
  } = useCartStore();

  useEffect(() => {
    setIsVisible(
      router.state.location.pathname !== '/rules' &&
        router.state.location.pathname !== '/privacy' &&
        router.state.location.pathname !== '/challenges' &&
        !router.state.location.pathname.startsWith('/challenge/')
    );
  }, [router.state.location.pathname]);

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        // First try to get from localStorage
        const userDataString = localStorage.getItem('liga:userData');
        let credits = 0;

        if (userDataString) {
          try {
            const userData = JSON.parse(userDataString);
            if (userData?.partnerDatum) {
              const {
                totalCredit = 0,
                extraCredit = 0,
                usedCredit = 0,
              } = userData.partnerDatum;
              credits = totalCredit + extraCredit - usedCredit;
            }
          } catch (error) {
            console.error('Error parsing userData from localStorage', error);
          }
        }

        const userData = await getMe();
        if (userData?.partnerDatum) {
          const {
            totalCredit = 0,
            extraCredit = 0,
            usedCredit = 0,
          } = userData.partnerDatum;
          credits = totalCredit + extraCredit - usedCredit;
        }

        updateAvailableCredits(credits);
      } catch (error) {
        console.error('Error fetching credits:', error);
      }
    };

    fetchCredits();
  }, [updateAvailableCredits]);

  if (!isVisible) return null;

  if (availableCredits === 0 && !localStorage.getItem('liga:userData')) {
    return <p>Pontok betöltése...</p>;
  }

  const totalCartCredits = getTotalCartCredits();
  const remainingCredits = availableCredits - totalCartCredits;

  return (
    <div className="rounded-sm shadow-2xl p-4 fixed top-24 right-4 2xl:right-6 bg-white z-50  border-2 border-slate-200">
      <div className="flex flex-col gap-4">
        <div>
          <p className="font-bold text-right">
            Beváltható kreditek:{' '}
            <span className="font-heineken text-heineken-green">
              {Math.floor(remainingCredits)}
            </span>
          </p>
          {totalCartCredits > 0 && (
            <p className="text-sm text-gray-500 text-right">
              Kosárban: {totalCartCredits} kredit
            </p>
          )}
        </div>

        {products.length > 0 && (
          <>
            <div className="border-t pt-4">
              <p className="font-bold text-sm mb-2">Kosár tartalma:</p>
              <ul className="flex flex-col gap-2">
                {products.map((product) => (
                  <li
                    key={product.id}
                    className="flex items-center justify-between text-sm"
                  >
                    <span className="truncate flex-1">
                      {product.name} ({product.quantity}x)
                    </span>
                    <div className="flex items-center gap-2 shrink-0">
                      <span className="text-heineken-green font-bold">
                        {product.price * product.quantity}
                      </span>
                      <Button
                        size="icon"
                        variant="ghost"
                        className="size-6 hover:bg-slate-100"
                        onClick={scrollToCart}
                      >
                        <PencilIcon className="size-3" />
                      </Button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <Button
              variant="outline"
              className="w-full border-heineken-green text-heineken-green hover:bg-heineken-green hover:text-white"
              onClick={scrollToCart}
            >
              Kosárhoz
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
